/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../core/enums';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { GalleryScreenComponent } from '../../../core/usecases';
import { GridTypes } from '../../../core/utils/GridTypes';
import { Caret } from '../../common';

import './InteractiveLayer.scss';

const InteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );
    const totalItemsInCurrentPage = useTivoSelector(
        (state: RootState) => state.grid[GridTypes.GALLERY]?.items,
    );

    const isCaretVisible =
        totalItemsInCurrentPage && Object.keys(totalItemsInCurrentPage).length > 0;

    const galleryScreen = new GalleryScreenComponent();
    const mCurrentPage = GalleryScreenComponent.getCurrentPage();
    const mTotalItems = GalleryScreenComponent.getTotalItems();
    const mMaxItemsInPage = galleryScreen.getMaxItemsInPage();

    const isFirstPage = mCurrentPage === 0;
    const isLastPage = mCurrentPage === Math.ceil(mTotalItems / mMaxItemsInPage) - 1;
    const showNorthCaret = !isFirstPage && isCaretVisible;
    const showSouthCaret = !isLastPage && isCaretVisible;

    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.NORTH}
                visible={showNorthCaret && activeComponent === InteractiveComponents.NORTH}
                active={activeComponent === InteractiveComponents.NORTH}
                className="gallery-north"
            />

            <Caret
                direction={InteractiveComponents.SOUTH}
                visible={showSouthCaret && activeComponent === InteractiveComponents.SOUTH}
                active={activeComponent === InteractiveComponents.SOUTH}
                className="gallery-south"
            />
        </React.Fragment>
    );
};

export default InteractiveLayer;
